import clsx from 'clsx';
import Select, { Props } from 'react-select';

import styles from './DrillxReactSelect.module.scss';

type OptionTypeBase = { label: string; value: string };

const DrillxReactSelect = <OptionType extends OptionTypeBase = { label: string; value: string }>({
  className,
  ...otherProps
}: Props<OptionType>) => (
  <Select
    {...otherProps}
    classNamePrefix="common-react-select"
    className={clsx(styles.commonReactSelect, className)}
  />
);

export default DrillxReactSelect;
